import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  bar$ = new EventEmitter<any>();
  chart$ = new EventEmitter<any>();
  chart: string = 'bar';
}
